'use client';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomerReview from "../util/CustomerReview.jsx";
import PaymentV1 from "./PaymentV1.jsx";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { getLink } from "../../dataProvider/links.js";
import { registerUser } from "../../actions/user.js";
import config from "../../config.js";
import PricingBlock from "../util/PricingBlock.jsx";
import { pdfjs, Document, Page } from "react-pdf";

import paymentLeftImageV2 from "../../img/v2/payment/paymentLeftImage.png";
import paymentLeftCompressImageV2 from "../../img/v2/payment/paymentLeftImageCompress.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { getIcon } from "../../dataProvider/uploadIcons.js";
import mime from "mime";
import moment from "moment";
import timerImg from "../../img/v2/payment/timer.svg";

import "../../scss/v2/payment.scss"
import useWindowDimensions from "../util/Window.js";

// @ts-expect-error This does not exist outside of polyfill which this is doing
if (typeof Promise.withResolvers === 'undefined') {
  if (window)
    // @ts-expect-error This does not exist outside of polyfill which this is doing
    window.Promise.withResolvers = function () {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
}

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/legacy/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

function Payment(props) {
  const { t, i18n } = useTranslation();
  const { width } = useWindowDimensions();
  const [registerPending, setRegisterPending] = useState(false);
  const [averageBsGain, setAverageBsGain] = useState(0);
  const [displayFilename, setDisplayFilename] = useState('');
  const [firstFileData, setFirstFileData] = useState({});
  const [customerType, setCustomerType] = useState();
  const [timeout, setTimeout] = useState(300);
  const [timeoutEnd, setTimeoutEnd] = useState(false);
  const [pdfCanBeDisplayed, setPdfCanBeDisplayed] = useState(false);
  let navigate = useNavigate();
  var decrementTimeout;

  function alertUser(e) {
    e.preventDefault();
    e.returnValue = "";
  }

  useEffect(() => {
    var newValue = timeout;

    decrementTimeout = setInterval(() => {
      newValue -= 1;
      setTimeout(newValue);
    }, 1000);

    return () => {
      clearInterval(decrementTimeout);
    };
  }, [timeoutEnd]);

  useEffect(() => {
    if (timeout > 0) return;
    clearInterval(decrementTimeout);

    window.onbeforeunload = () => { };
    window.removeEventListener("beforeunload", alertUser);

    setTimeoutEnd(true);
  }, [timeout, timeoutEnd]);

  useEffect(() => {
    if (!timeoutEnd) return;

    console.log(getLink("home", i18n.language))

    navigate(getLink("home", i18n.language));
  }, [timeoutEnd]);

  useEffect(() => {
    if (mime.getType(firstFileData?.ext) === "application/pdf" && firstFileData.url) setPdfCanBeDisplayed(true);
  }, [firstFileData]);


  useEffect(() => {
    if ((props.mode !== "compress" && props.mode !== "convert") || !props.file.files || props.file.files.length === 0) return;
    const file = props.file.files.find((e) => e.mode === props.mode);
    const fileName = props.file.files[0].name;
    const ext = fileName.substring(fileName.lastIndexOf('.'));
    const name = fileName.substring(0, fileName.lastIndexOf('.'));
    const convertTo = (file.mode === "convert") ? `.${file.convertTo}` : ext;
    setDisplayFilename((name.length > 19) ? `${name.substr(0, 16)}...${name.substr(-3)}${convertTo}` : `${name}${convertTo}`)
    setFirstFileData({ file: fileName, ext: ext.substring(1), name, convertTo, url: props.file.files[0].url });
  }, [props.mode, props.file]);




  useEffect(() => {
    if (props.mode !== "compress" || !props.file.files || props.file.files.length === 0) return;
    const filesCompressed = props.file.files.reduce((acc, value) => {
      return (value.mode === "compress") ? acc + 1 : acc;
    }, 0)

    setAverageBsGain(props.file.files.reduce((acc, value) => {
      if (value.mode !== "compress") return acc;
      return acc + value.bsGain;
    }, 0) / filesCompressed);
  }, [props.mode, props.file]);

  useEffect(() => {
    if (!props.file.files || props.file.files.length === 0) return navigate(getLink("home", i18n.language));
    if (!registerPending && !props.user?.id && props.email) {
      const type = props.file.files[0].mode
      setRegisterPending(true);
      const user = {
        email: props.email,
        products: [props.product.id],
        metadata: {
          customerServicePhone: t('footer.link.contact.phone.number'),
          unsubscribeAction: config.actions.unsubscribe[i18n.language],
          conversionAction: config.actions.conversion[i18n.language],
          paymentSuccessUrl: `${getLink("paymentSecure", i18n.language)}?status=success`,
          paymentErrorUrl: `${getLink("paymentSecure", i18n.language)}?status=error`,
          language: window.navigator.language,
          colorDepth: window.screen.colorDepth,
          screenHeight: window.screen.height,
          screenWidth: window.screen.width,
          tzOffset: new Date().getTimezoneOffset(),
          type,
          marketingEmailSuffix: type
        },
      };
      props.dispatch(registerUser(user)).then(() => setRegisterPending(false));
    }
  }, [i18n.language, props, navigate, registerPending, t]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, [])


  function renderReviews() {
    return (
      <div className="row">
        <div className="col-12 col-lg-6">
          <div className={`payment-review-card`}>
            <CustomerReview index={0} noImg={true} />
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className={`payment-review-card`}>
            <CustomerReview index={1} noImg={true} />
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className={`payment-review-card`}>
            <CustomerReview index={2} noImg={true} />
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className={`payment-review-card`}>
            <CustomerReview index={3} noImg={true} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`payment container-lg`}>
      <div className="row">
        {" "}
        <div className="col-12 col-lg-10 offset-lg-1">
          <div className="row">
            <div className={`col-12 col-lg-8 no-padding-mobile`}>
              <PaymentV1 onCustomerTypeChange={setCustomerType} displayTimer={(width <= 992)} timeout={timeout} />
              <div className="payment-underPayment-card">
                <p className="payment-underPayment-card-text">
                  {t("payment.underPayment.card.text")}
                </p>
              </div>
              <div className="d-none d-lg-block">{renderReviews()}</div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="payment-recapBlock">
                <div className="payment-separator"></div>
                <h2
                  className="payment-recapBlock-title"
                  dangerouslySetInnerHTML={{ __html: t("payment.recapBlock.title"), }}
                />
                <div className="payment-recapBlock-image-container">
                  {(props.mode !== "convert") ? (
                    <img className="img img-fluid payment-recapBlock-image" src={(props.mode === "compress") ? paymentLeftCompressImageV2 : paymentLeftImageV2} alt={paymentLeftImageV2} />
                  ) : (
                    <>
                      <div>
                        {(pdfCanBeDisplayed) ? (
                          <Document file={firstFileData?.url} className="payment-recapBlock-image-pdf" onLoadError={() => setPdfCanBeDisplayed(false)}>
                            <Page pageNumber={1} width={80} renderTextLayer={false} renderAnnotationLayer={false} />
                          </Document>
                        ) : null}
                      </div>
                      <div className="payment-recapBlock-image-container-convert">
                        <span className="img img-fluid" dangerouslySetInnerHTML={{ __html: getIcon(firstFileData?.ext) }} />
                        <FontAwesomeIcon size="xl" className="payment-recapBlock-image-container-convert-arrow" icon={faArrowRight} />
                        <span className="img img-fluid" dangerouslySetInnerHTML={{ __html: getIcon(firstFileData?.convertTo) }} />
                      </div>
                    </>
                  )}
                  {props.mode === "compress" && (<div className="payment-recapBlock-compress-bsGain">{`-${averageBsGain}%`}</div>)}
                </div>
                <p className="payment-recapBlock-filename">{displayFilename}</p>
                <div className="payment-separator"></div>
                { (width > 992) ? (
                  <DisplayTimeout timeout={timeout} />
                ) : null }
                <p className="payment-recapBlock-green-title" dangerouslySetInnerHTML={{ __html: t("payment.recapBlock.command.title"), }} />
                <p className="payment-recapBlock-info" dangerouslySetInnerHTML={{ __html: t(`payment.recapBlock.command${props.mode === "compress" ? "Compress" : props.mode === "split" ? "Split" : ""}.text`, { acqPrice: props.product.acqPrice, subPrice: props.product.subPrice }) }} />
                <p className="payment-recapBlock-green-title" dangerouslySetInnerHTML={{ __html: t("payment.recapBlock.offer.title") }} />
                <p className="payment-recapBlock-info" dangerouslySetInnerHTML={{ __html: t(`payment.recapBlock.offer.${customerType}.text`, { acqPrice: props.product.acqPrice, subPrice: props.product.subPrice }) }} />
                <p className="payment-recapBlock-green-title" dangerouslySetInnerHTML={{ __html: t("payment.recapBlock.email.title") }} />
                <p className="payment-recapBlock-info">{props.email}</p>
                <div className="payment-separator last-separator"></div>
                <div className="d-block d-lg-none">{renderReviews()}</div>
                <div className="payment-recapBlock-card">
                  <p className="payment-recapBlock-card-text" dangerouslySetInnerHTML={{ __html: t(`payment.recapBlock.card.${customerType}.text`, { acqPrice: props.product.acqPrice, subPrice: props.product.subPrice }) }} />
                </div>
                <p className="payment-recapBlock-small-info" dangerouslySetInnerHTML={{ __html: t("payment.recapBlock.small.info", { acqPrice: props.product.acqPrice, subPrice: props.product.subPrice }) }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <PricingBlock />
    </div>
  );
}

export function DisplayTimeout({ timeout }) {

  const { t } = useTranslation();

  return (
    <div className={'payment-timeoutBlock'}>
      <img src={timerImg} width={20} height={20} alt="alarmClock" />
      <div>
        <span>{t('payment.timeout.text1')}</span>
        <span>{t('payment.timeout.text2', {timer: moment.utc(timeout*1000).format('mm:ss') })}</span>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  email: state.user.email,
  file: state.file,
  user: state.user.user,
  mode: state.mode.mode,
  product: state.product.product
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
